import { SOFTLINE_CONFIG_INDEXED_DB } from '@softline/core';
import { SOFTLINE_INDEXED_DB_CONTEXT } from './context.indexed-db';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

export const contextStorageProviders = [
  { provide: SOFTLINE_CONFIG_INDEXED_DB, useValue: SOFTLINE_INDEXED_DB_CONTEXT, multi: true },
]
